/* EnterView  */
const reveals = document.querySelectorAll('.reveal');
const revealUps = document.querySelectorAll('.reveal-up');

if (reveals.length > 0) {
  enterView({
    selector: '.reveal',
    enter: (el, i) => {
      el.classList.add('entered');
    },
    exit: el => {
      el.classList.remove('entered');
    },
    offset: 0.1
  });
}

if (revealUps.length > 0) {
  enterView({
    selector: '.reveal-up',
    enter: (el, i) => {
      el.classList.add('entered');
    },
    exit: el => {
      el.classList.remove('entered');
    },
    offset: 0.1
  });
}

/* Swiper Initialiser */
document
  .querySelectorAll('.featured-collection__items.swiper')
  .forEach(el => {
    new Swiper(el, {
      slidesPerView: 1.5,
      breakpoints: {
        768: {
          slidesPerView: 3.5
        },
        1024: {
          slidesPerView: 6
        }
      }
    });
  });

/* Scrolling Cards Swiper */

function initCardsSwiper(el) {
  if (!el || typeof Swiper === 'undefined' || el.swiper) return;

  const swiper = new Swiper(el, {
    slidesPerView: 1.2,
    spaceBetween: 0,
    freeMode: true,
    loop: true,
    speed: 7500,
    autoplay: {
      delay: 0,
      disableOnInteraction: true,
    },
    breakpoints: {
      750: {
        slidesPerView: 2.7,
      },
    },
  });


}

document
  .querySelectorAll('[data-cards-swiper].swiper')
  .forEach(initCardsSwiper);

/* Books carousel */
document.querySelectorAll('.books-carousel__swiper.swiper').forEach(el => {
  const section = el.closest('.books-carousel');
  const nextEl = section?.querySelector('.books-carousel__nav');

  new Swiper(el, {
    slidesPerView: 2.1,
    spaceBetween: 14,
    grabCursor: true,
    navigation: {
      nextEl
    },
    breakpoints: {
      768: {
        slidesPerView: 2.3,
        spaceBetween: 24,
      },
      1024: {
        slidesPerView: 4.4
      }
    }
  });
});

/* Testimonials carousel */
document
  .querySelectorAll('.testimonials__carousel.swiper')
  .forEach(el => {
    new Swiper(el, {
      slidesPerView: 1.3,
      spaceBetween: 46,
      loop: true,
      grabCursor: true,
      observer: true,
      observeParents: true,
      slidesOffsetBefore: 20,
      slidesOffsetAfter: 20,
      breakpoints: {
        768: {
          spaceBetween: 46,
          centeredSlides: true,
          slidesOffsetBefore: 0,
          slidesOffsetAfter: 0
        },
        1024: {
          slidesPerView: 1.5,
          spaceBetween: 80,
          centeredSlides: true,
          slidesOffsetBefore: 0,
          slidesOffsetAfter: 0
        }
      }
    });
  });

new Swiper('.announcement-swiper', {
  loop: true,
  slidesPerView: 1,
  allowTouchMove: false,
  autoplay: {
    delay: 3500,
    disableOnInteraction: false
  },
  speed: 800
});

/* Multicolumn: swiper on mobile/tablet only */
(function () {
  const mq = window.matchMedia('(max-width: 1023px)');
  document
    .querySelectorAll('.multicolumn__items.swiper')
    .forEach(el => {
      let instance = null;
      function update() {
        if (mq.matches && !instance) {
          instance = new Swiper(el, {
            slidesPerView: 1.5,
            slidesOffsetBefore: 20,
            slidesOffsetAfter: 20,
            breakpoints: {
              768: {
                slidesPerView: 2.5
              }
            }
          });
        } else if (!mq.matches && instance) {
          instance.destroy(true, true);
          instance = null;
        }
      }
      update();
      mq.addEventListener('change', update);
    });
})();

// MOBILE VIEWPORT HEIGHT FIX
let vh = window.innerHeight * 0.01;
document.documentElement.style.setProperty('--vh', `${vh}px`);

window.addEventListener('resize', () => {
  let vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty('--vh', `${vh}px`);
});

/* Toggle Class (Generic) */
function toggleClass(modalName, className = 'active') {
  var modalActive = document.querySelector(modalName);
  modalActive.classList.toggle(className);
}

function toggleMultipleClass(
  selector1,
  selector2,
  className = 'active'
) {
  const el1 = document.querySelector(selector1);
  const el2 = document.querySelector(selector2);

  if (el1) el1.classList.toggle(className);
  if (el2) el2.classList.toggle(className);
}

/* Toggle forgot password form */
const forgotPasswordButtons = document.querySelectorAll(
  '.login__forgot-password-button'
);

forgotPasswordButtons.forEach(button => {
  button.addEventListener('click', function (e) {
    e.preventDefault();
    toggleClass('.login__form');
    toggleClass('.forgot-password-form');
  });
});

/* Open Cart */
function cartOpen() {
  document.querySelector('body').classList.add('js-my-cart-open');
}

/* FAQ Accordion */
document.querySelectorAll('[data-faq-item]').forEach(item => {
  const trigger = item.querySelector('[data-faq-trigger]');
  if (!trigger) return;
  trigger.addEventListener('click', () => {
    const isOpen = item.classList.contains('is-open');
    item.classList.toggle('is-open', !isOpen);
    trigger.setAttribute('aria-expanded', String(!isOpen));
  });
});

/* Lazy Load Initialiser */
var lazyLoadInstance = new LazyLoad({});

/* Liquid Ajax Cart */
liquidAjaxCart.subscribeToCartAjaxRequests(
  (state, subscribeToResult) => {
    if (state.requestType == 'add') {
      const form = state.info.initiator;
      let btnInner = '';

      const btn = form.querySelector('button[type="submit"]');
      if (btn) {
        btnInner = btn.innerHTML;
        btn.innerHTML = 'Adding';
      }

      subscribeToResult(state => {
        const btn = form.querySelector('button[type="submit"]');
        if (state.responseData.ok) {
          cartOpen();
        }

        if (btn) {
          setTimeout(() => {
            btn.innerHTML = btnInner;
          }, 300);
        }
      });
    }
  }
);

/* Hero Slider */
function initHeroSlider(context = document) {
  const sliders = context.querySelectorAll('.hero-slider .swiper');
  if (!sliders.length) return;

  sliders.forEach(sliderEl => {
    if (sliderEl.classList.contains('swiper-initialized')) return;

    const wrapper = sliderEl.closest('.hero-slider');
    const progressBars = wrapper.querySelectorAll(
      '.progress-bar__fill'
    );
    const navButtons = wrapper.querySelectorAll('.hero-slider__btn');

    let hasTriggered = false;

    const swiper = new Swiper(sliderEl, {
      loop: true,
      speed: 600,
      autoplay: {
        delay: 5000,
        disableOnInteraction: false
      },
      effect: 'fade',
      fadeEffect: {
        crossFade: true
      },

      on: {
        init() {
          setActiveNav(this.realIndex);
        },

        slideChange(swiper) {
          setActiveNav(swiper.realIndex);

          hasTriggered = false;
        },

        autoplayTimeLeft(swiper, time, progress) {
          const activeIndex = swiper.realIndex;
          const percentage = (1 - progress) * 100;

          progressBars.forEach((bar, i) => {
            if (i < activeIndex) {
              bar.style.width = '100%';
            } else if (i === activeIndex) {
              bar.style.width = `${percentage}%`;
            } else {
              bar.style.width = '0%';
            }
          });

          if (percentage > 92 && !hasTriggered) {
            hasTriggered = true;
            swiper.slideNext();
          }
        }
      }
    });

    function setActiveNav(index) {
      navButtons.forEach(btn => btn.classList.remove('is-active'));
      if (navButtons[index]) {
        navButtons[index].classList.add('is-active');
      }
    }

    navButtons.forEach(btn => {
      btn.addEventListener('click', () => {
        const index = parseInt(btn.dataset.slide);
        swiper.slideToLoop(index);

        hasTriggered = false;
      });
    });
  });
}

// Load more button function (collections, search)
function initLoadMore() {
  const buttons = document.querySelectorAll('.js-load-more');
  if (!buttons.length) return;

  buttons.forEach(button => {
    if (button.dataset.initialized) return;
    button.dataset.initialized = true;

    button.addEventListener('click', function () {
      const nextUrl = button.dataset.nextUrl;
      const containerSelector = button.dataset.container;

      if (!nextUrl || !containerSelector) return;

      const container = document.querySelector(containerSelector);
      if (!container) return;

      button.classList.add('is-loading');

      fetch(nextUrl)
        .then(response => response.text())
        .then(html => {
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, 'text/html');

          const newContainer = doc.querySelector(containerSelector);
          const newButton = doc.querySelector('.js-load-more');

          if (newContainer) {
            const temp = document.createElement('div');
            temp.innerHTML = newContainer.innerHTML;

            const newItems = temp.querySelectorAll('.reveal-up');

            newItems.forEach(el => {
              el.classList.remove('entered');
            });

            while (temp.firstChild) {
              container.appendChild(temp.firstChild);
            }

            requestAnimationFrame(() => {
              newItems.forEach((el, i) => {
                el.classList.add('entered');
              });
            });
          }
          if (newButton) {
            button.dataset.nextUrl = newButton.dataset.nextUrl;
          } else {
            button.remove();
          }
        })
        .finally(() => {
          button.classList.remove('is-loading');
        });
    });
  });
}

// END OF LOAD MORE BUTTON

// Account nav
function handleAccountPageNav() {
  const pathname = window.location.pathname;
  const hash = window.location.hash;
  const links = document.querySelectorAll('.account-nav-link');

  if (!links.length) return;

  links.forEach(link => link.classList.remove('active'));

  if (pathname === '/account') {
    const sections = document.querySelectorAll('.account-section');

    sections.forEach(section => section.classList.add('hidden'));

    const currentHash = hash || '#dashboard';
    const sectionId = currentHash.replace('#', 'account-');
    const activeSection = document.getElementById(sectionId);
    if (activeSection) {
      activeSection.classList.remove('hidden');
    }

    links.forEach(link => {
      const hrefHash = link.getAttribute('href').split('#')[1];
      if (`#${hrefHash}` === currentHash) {
        link.classList.add('active');
      }
    });

    if (!hash) {
      window.history.replaceState(
        null,
        '',
        `${window.location.pathname}#dashboard`
      );
    }
  }

  if (pathname.includes('/account/addresses')) {
    const addressLink = document.getElementById('addresses-link');
    addressLink?.classList.add('active');
  }
}

// Product Recommendations (PDP)
function initProductRecommendations(context = document) {
  const sections = context.querySelectorAll(
    '[data-product-recommendations]'
  );
  if (!sections.length) return;

  sections.forEach(section => {
    if (section.dataset.loaded === 'true') return;

    const url = section.dataset.url;

    // Manual/metafield mode — products are already in the DOM, just init the swiper
    if (!url) {
      const wrapper = section.querySelector('.swiper-wrapper');
      if (wrapper && wrapper.children.length > 0) {
        initRecommendationSwiper(section);
        section.dataset.loaded = 'true';
      }
      return;
    }

    const wrapper = section.querySelector('.swiper-wrapper');
    if (!wrapper) return;

    fetch(url)
      .then(res => res.text())
      .then(html => {
        const temp = document.createElement('div');
        temp.innerHTML = html;

        const newSlides = temp.querySelectorAll(
          '.product-recommendations__card'
        );
        if (!newSlides.length) return;

        wrapper.innerHTML = '';

        newSlides.forEach(slide => {
          wrapper.appendChild(slide);
        });

        initRecommendationSwiper(section);

        section.dataset.loaded = 'true';
      })
      .catch(err => {
        console.error('Recommendation fetch failed:', err);
      });
  });
}

// Product recommendations swiper
function initRecommendationSwiper(section) {
  const swiperEl = section.querySelector(
    '[data-recommendation-swiper]'
  );
  if (!swiperEl) return;

  if (swiperEl.swiper) {
    swiperEl.swiper.destroy(true, true);
  }

  new Swiper(swiperEl, {
    direction: 'horizontal',
    slidesPerView: 'auto',
    spaceBetween: 16,
    slidesOffsetBefore: 16,
    slidesOffsetAfter: 16,
    breakpoints: {
      768: {
        slidesPerView: 'auto',
        spaceBetween: 20,
        slidesOffsetBefore: 16,
        slidesOffsetAfter: 16
      },
      1024: {
        slidesPerView: 'auto',
        spaceBetween: 150,
        slidesOffsetBefore: 0,
        slidesOffsetAfter: 0
      }
    }
  });
}

// Collection Filtering //
function initCollectionFacets() {
  const collectionPage = document.querySelector(
    '.js-collection-page'
  );
  if (!collectionPage) return;

  const modal = collectionPage.querySelector('#FiltersModal');
  const openBtn = collectionPage.querySelector('.open-filters');
  const closeBtn = collectionPage.querySelector('.filters-close');
  const overlay = collectionPage.querySelector('.filters-overlay');
  const form = collectionPage.querySelector('#FiltersForm');
  const countEl = collectionPage.querySelector('#ActiveFilterCount');
  const headerCountEl = collectionPage.querySelector(
    '#ActiveFilterCountHeader'
  );
  const applyButton = collectionPage.querySelector(
    '.filter__apply-button'
  );

  if (!modal) return;

  // Open/close modal
  const openModal = () => {
    modal.classList.add('active');
    document.body.classList.add('no-scroll');
  };

  const closeModal = () => {
    modal.classList.remove('active');
    document.body.classList.remove('no-scroll');
  };

  openBtn?.addEventListener('click', openModal);
  closeBtn?.addEventListener('click', closeModal);
  overlay?.addEventListener('click', closeModal);
  form?.addEventListener('submit', closeModal);

  // Accordion
  collectionPage
    .querySelectorAll('.js-accordion-toggle')
    .forEach(toggle => {
      toggle.addEventListener('click', e => {
        e.preventDefault();
        const group = toggle.closest('.filter-group');
        const options = group?.querySelector('.filter-options');
        options?.classList.toggle('active');
        toggle.classList.toggle('active');
      });
    });

  // checkbox states
  const syncActiveCheckboxes = () => {
    collectionPage
      .querySelectorAll('.filter-options input[type="checkbox"]')
      .forEach(input => {
        const label = input.closest('label');
        if (!label) return;
        label.classList.toggle('is-active', input.checked);
      });
  };

  collectionPage.addEventListener('change', e => {
    const input = e.target;

    if (input.type === 'checkbox' || input.type === 'radio') {
      const label = input.closest('label');
      label?.classList.toggle('is-active', input.checked);

      // For radios, remove active from siblings
      if (input.type === 'radio') {
        const radios = collectionPage.querySelectorAll(
          `input[name="${input.name}"]`
        );
        radios.forEach(radio => {
          const l = radio.closest('label');
          l?.classList.toggle('is-active', radio.checked);
        });
      }
    }

    updateFilterCount();
    updateProductCount();
  });

  const updateFilterCount = () => {
    if (!form) return;

    let count = 0;

    const checkedBoxes = form.querySelectorAll(
      'input[type="checkbox"]:checked'
    );
    count += checkedBoxes.length;

    const minInput = form.querySelector(
      'input[name*="filter.v.price.gte"]'
    );
    const maxInput = form.querySelector(
      'input[name*="filter.v.price.lte"]'
    );

    if (minInput?.value || maxInput?.value) {
      count += 1;
    }

    const formatted = count > 0 ? `(${count})` : '';

    if (countEl) countEl.textContent = formatted;
    if (headerCountEl) headerCountEl.textContent = formatted;
  };

  const updateProductCount = async () => {
    if (!form || !applyButton) return;

    const url = new URL(form.action, window.location.origin);
    const params = new URLSearchParams();

    // Checkboxes
    form
      .querySelectorAll('input[type="checkbox"]:checked')
      .forEach(input => {
        params.append(input.name, input.value);
      });

    // Radios
    form
      .querySelectorAll('input[type="radio"]:checked')
      .forEach(input => {
        params.append(input.name, input.value);
      });

    // Price range
    const minInput = form.querySelector(
      'input[name*="filter.v.price.gte"]'
    );
    const maxInput = form.querySelector(
      'input[name*="filter.v.price.lte"]'
    );

    if (minInput?.value) {
      params.append(minInput.name, minInput.value);
    }

    if (maxInput?.value) {
      params.append(maxInput.name, maxInput.value);
    }

    try {
      const response = await fetch(
        `${url.pathname}?${params.toString()}`
      );
      const html = await response.text();

      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');

      const countEl = doc.querySelector('.collection__filter-number');
      const productCount =
        countEl?.textContent.match(/\d+/)?.[0] || 0;

      applyButton.textContent = `View ${productCount} Products`;
    } catch (error) {
      console.error('Error fetching product count:', error);
    }
  };

  syncActiveCheckboxes();
  updateFilterCount();
}

// Announcement bar
function initAnnouncementBar() {
  const body = document.body;
  const bar = document.getElementById('announcement-bar');

  if (!bar) return;

  bar.classList.remove('hidden-by-default');
  body.classList.add('announcement-bar-visible');
}

function initGeoModal() {
  const modal = document.getElementById('geo-modal');
  if (!modal) return;

  if (localStorage.getItem('geoModalSeen')) return;

  const shopBtn = modal.querySelector('#geo-modal-shop');

  setTimeout(() => {
    modal.classList.add('active');
  }, 1200);

  function closeModal() {
    modal.classList.remove('active');
    localStorage.setItem('geoModalSeen', 'true');
  }

  shopBtn?.addEventListener('click', () => {
    const form = modal.querySelector('form');

    localStorage.setItem('geoModalSeen', 'true');

    if (form && form.dataset.currencyChanged === 'true') {
      form.submit();
    } else {
      closeModal();
    }
  });
}

function initCurrencySelectors() {
  const selectors = document.querySelectorAll('.currency-selector');
  if (!selectors.length) return;

  selectors.forEach(selector => {
    const form = selector.closest('form');
    const insideModal = selector.closest('#geo-modal');

    resizeCurrencySelector(selector);

    selector.addEventListener('change', () => {
      resizeCurrencySelector(selector);

      if (insideModal) {
        form.dataset.currencyChanged = 'true';
        return;
      }

      form.submit();
    });
  });
}

function resizeCurrencySelector(selector) {
  let temp = selector._tempMeasure;

  if (!temp) {
    temp = document.createElement('span');
    temp.style.visibility = 'hidden';
    temp.style.position = 'absolute';
    temp.style.whiteSpace = 'nowrap';
    temp.style.font = window.getComputedStyle(selector).font;

    document.body.appendChild(temp);
    selector._tempMeasure = temp;
  }

  const text = selector.options[selector.selectedIndex].text;
  temp.textContent = text;

  const textWidth = temp.offsetWidth;

  const style = window.getComputedStyle(selector);
  const padding =
    parseFloat(style.paddingLeft) + parseFloat(style.paddingRight);

  const buffer = 24;

  selector.style.width = textWidth + padding + buffer + 'px';
}

// Cart drawer quantity stepper — delegated so it survives liquid-ajax-cart
// section re-renders without needing to re-bind listeners.
document.addEventListener('click', function (e) {
  const btn = e.target.closest('[data-cart-qty-action]');
  if (!btn) return;
  const wrap = btn.closest('[data-cart-qty]');
  if (!wrap) return;
  const input = wrap.querySelector('input[data-ajax-cart-quantity-input]');
  if (!input) return;
  const current = parseInt(input.value, 10) || 0;
  const next =
    btn.dataset.cartQtyAction === 'increase'
      ? current + 1
      : Math.max(0, current - 1);
  if (next === current) return;
  input.value = next;
  input.dispatchEvent(new Event('change', { bubbles: true }));
});

// Init functions
window.addEventListener('hashchange', handleAccountPageNav);

document.addEventListener('DOMContentLoaded', function () {
  initLoadMore();
  handleAccountPageNav();
  initProductRecommendations();
  initCollectionFacets();
  initAnnouncementBar();
  initGeoModal();
  initCurrencySelectors();
  initHeroSlider();
});

document.addEventListener('shopify:section:load', event => {
  event.target
    .querySelectorAll('[data-cards-swiper].swiper')
    .forEach(initCardsSwiper);
  initProductRecommendations(event.target);
  initHeroSlider(event.target);
});
